import { createQuerySuggestionsPlugin } from "@algolia/autocomplete-plugin-query-suggestions";

import Algolia from "~/types/algolia";
import CommonUtils from "~/utils/common-utils";

import { searchClient } from "../search-client";
import { ProductHit, ProductHitType } from "./products-plugin";

export const popularPlugin = (algoliaIndexId: string, width: number, locale: string, currency: string) => {
  const algoliaSearchConfig = CommonUtils.parseJsonSafely(
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_CONFIG!
  ) as Algolia.Configuration;
  const distinct = algoliaSearchConfig?.distinct;

  return createQuerySuggestionsPlugin({
    searchClient,
    indexName: algoliaIndexId,
    getSearchParams() {
      return {
        query: "",
        hitsPerPage: width >= 1280 ? 8 : width >= 900 ? 6 : 4,
        distinct,
      };
    },
    transformSource({ source }) {
      return {
        ...source,
        sourceId: "popularPlugin",
        getItemInputValue({ item }) {
          return item.query;
        },
        onSelect({ setIsOpen }) {
          setIsOpen(true);
        },
        templates: {
          item({ item }) {
            return <ProductHit hit={item as unknown as ProductHitType} locale={locale} currency={currency} />;
          },
        },
      };
    },
  });
};
